var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobility = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mobility_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mobility_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.253 10.027a2.9 2.9 0 0 1-2.126-.887 2.902 2.902 0 0 1-.887-2.127 2.9 2.9 0 0 1 .887-2.126A2.9 2.9 0 0 1 11.253 4a2.9 2.9 0 0 1 2.127.887 2.9 2.9 0 0 1 .886 2.126c0 .827-.295 1.536-.886 2.127a2.9 2.9 0 0 1-2.127.887ZM8.853 36V24.8h-3.2V12.187h11.2v6.986c-1.466.907-2.66 2.151-3.58 3.734-.92 1.582-1.38 3.315-1.38 5.2 0 1.217.191 2.349.573 3.393.383 1.044.868 1.94 1.454 2.687V36H8.853Zm13.6 0c-2.177 0-4.037-.767-5.58-2.3-1.542-1.533-2.313-3.398-2.313-5.593 0-1.663.509-3.216 1.527-4.66 1.017-1.445 2.429-2.416 4.233-2.914v2.92a4.665 4.665 0 0 0-2.273 1.907c-.547.88-.82 1.796-.82 2.747 0 1.457.506 2.693 1.52 3.706 1.013 1.014 2.248 1.52 3.706 1.52 1.512 0 2.783-.573 3.814-1.72 1.03-1.146 1.449-2.529 1.253-4.146h2.666c.232 2.249-.433 4.233-1.993 5.953-1.56 1.72-3.473 2.58-5.74 2.58Zm12.333-3.52-4.28-6.347h-8.853V13.867h2.667v9.6H32l5.013 7.546-2.227 1.467Z"
}))));
export default SvgMobility;